var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.582 89.1378C332.805 74.7288 365.497 66.6665 400 66.6665C524.247 66.6665 624.97 171.207 624.97 300.165V323.652C624.97 351.84 633.01 379.393 648.073 402.846L684.987 460.316C718.707 512.81 692.967 584.163 634.32 600.763C480.91 644.19 319.091 644.19 165.679 600.763C107.035 584.163 81.294 512.81 115.012 460.316L151.927 402.846C166.991 379.393 175.029 351.84 175.029 323.652V300.165C175.029 264.352 182.797 230.423 196.68 200.092",
    stroke: "white",
    strokeWidth: 50,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250 633.333C271.834 691.593 330.749 733.333 400 733.333C408.15 733.333 416.157 732.757 423.973 731.64M550 633.333C541.097 657.087 526.033 678.094 506.617 694.643",
    stroke: "white",
    strokeWidth: 50,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.b06ee6e1d656dd5567b02cbd612cc7df.svg";
export { ForwardRef as ReactComponent };